import { Button } from "../../components/ui";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

const tabs = [
  {
    name: "earnings",
    label: "Earnings",
    link: "",
    linkToCompare: "salary-structure",
  },
  // {
  //   name: "deductions",
  //   label: "Deductions",
  //   link: "deductions",
  //   linkToCompare: "deductions",
  // },
  {
    name: "statutory-components",
    label: "Statutory Components",
    link: "statutory-components",
    linkToCompare: "statutory-components",
  },
];

const breadcrumbs = [
  {
    label: "Company Settings",
    link: "/company-settings",
  },
  {
    label: "Salary Structure",
    link: "",
  },
];

const SalaryStructure = () => {
  const location = useLocation();

  const lastSegment = location.pathname.substring(
    location.pathname.lastIndexOf("/") + 1
  );

  const navigate = useNavigate();

  const openAddComponentPage = () => {
    navigate("/company-settings/salary-structure/add");
  };

  return (
    <>
      <div className="px-5 py-4">
        <BreadCrumbs crumbs={breadcrumbs} />
        <div className="flex justify-between items-center mb-6 mt-6">
          <h1 className=" text-xl font-bold ">Salary Structure</h1>

          {lastSegment === "salary-structure" && (
            <Button onClick={openAddComponentPage}>Add new component</Button>
          )}
        </div>

        <ul className="flex items-center mb-10">
          {tabs.map((tab) => (
            <li className={tab.linkToCompare === lastSegment ? "active" : ""}>
              <Link
                key={tab.name}
                className={`py-2 px-4 ${
                  tab.linkToCompare === lastSegment ? " " : ""
                }`}
                to={tab.link}
              >
                {tab.label}
              </Link>
            </li>
          ))}
        </ul>

        <Outlet />
      </div>
    </>
  );
};

export default SalaryStructure;
